/**
 * Normalizes Cloud Function / legacy payloads into `PlayerLookupData`.
 * Backend may use snake_case (Firestore) or camelCase.
 */
export function mapPlayerLookupRow(raw: unknown): player.PlayerLookupData {
  const r = raw as Record<string, unknown>;

  const id = String(r.id ?? '');
  const name = String(r.name ?? '');
  const level = Number(r.level ?? 0);

  const avatarUrl =
    (typeof r.avatar_url === 'string' && r.avatar_url) ||
    (typeof r.avatarUrl === 'string' && r.avatarUrl) ||
    (typeof r.profilePicture === 'string' && r.profilePicture) ||
    (typeof r.profile_picture === 'string' && r.profile_picture) ||
    null;

  return {
    id,
    name,
    level: Number.isFinite(level) ? level : 0,
    age: typeof r.age === 'number' ? r.age : r.age != null ? Number(r.age) : null,
    needClubs:
      typeof r.needClubs === 'boolean'
        ? r.needClubs
        : typeof r.need_clubs === 'boolean'
          ? r.need_clubs
          : null,
    lastAttended:
      (typeof r.lastAttended === 'string' && r.lastAttended) ||
      (typeof r.last_attended === 'string' && r.last_attended) ||
      null,
    totalQueryResults:
      typeof r.totalQueryResults === 'number'
        ? r.totalQueryResults
        : typeof r.total_query_results === 'number'
          ? r.total_query_results
          : null,
    avatarUrl: avatarUrl,
    profilePicture:
      (typeof r.profilePicture === 'string' && r.profilePicture) ||
      (typeof r.profile_picture === 'string' && r.profile_picture) ||
      avatarUrl,
  };
}

export function mapPlayersLookupResponse(
  data: player.PlayersLookupResponse,
): player.PlayerLookupData[] {
  if (!Array.isArray(data)) return [];
  return data.map(mapPlayerLookupRow);
}
